import { Link } from 'react-router-dom';
import { CheckCircle, Home, ArrowRight } from 'lucide-react';

const PaymentSuccess = () => {

  return (
    <div className="pt-32 sm:pt-48 pb-16 sm:pb-24 px-4 sm:px-6 bg-gradient-to-br from-white via-prose-brand/5 to-prose-gold/5 min-h-screen flex items-center">
      <div className="max-w-2xl mx-auto w-full">
        {/* Success Header */}
        <div className="text-center mb-12 sm:mb-16" data-aos="fade-up">
          <div className="inline-flex items-center justify-center w-14 sm:w-20 h-14 sm:h-20 bg-green-100 rounded-full mb-6 animate-bounce">
            <CheckCircle className="text-green-600" size={48} />
          </div>
          <h1 className="text-2xl sm:text-4xl lg:text-5xl font-display font-bold text-prose-black mb-6 sm:mb-8">
            Booking Confirmed!
          </h1>
          <p className="text-sm sm:text-base md:text-lg text-gray-600 mb-6">
            Your booking has been confirmed successfully. Check your email for confirmation details.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6" data-aos="fade-up" data-aos-delay="100">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-6 sm:px-8 py-3 sm:py-4 bg-prose-brand text-white rounded-lg font-semibold hover:bg-prose-brand/90 hover:-translate-y-1 hover:shadow-lg transition-all duration-300 text-xs sm:text-sm md:text-base"
          >
            <Home size={20} /> Back to Home
          </Link>
          <Link
            to="/properties"
            className="inline-flex items-center justify-center gap-2 px-6 sm:px-8 py-3 sm:py-4 border-2 border-prose-brand text-prose-brand rounded-lg font-semibold hover:bg-prose-brand/5 hover:-translate-y-1 hover:shadow-lg transition-all duration-300 text-xs sm:text-sm md:text-base"
          >
            View More <ArrowRight size={18} />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
